import React from 'react';
import { useHistory } from 'react-router-dom';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { Colors } from 'src/Tenants';
import { IStrataManagerUnit } from 'src/pages/StrataManagerSuites/types';
import './strata-manager-unit-card.scss';

interface StrataManagerUnitCardProps {
  unit: IStrataManagerUnit;
  to: string;
  propertyName: string;
}

const StrataManagerUnitCard = ({
  unit,
  to,
  propertyName,
}: StrataManagerUnitCardProps) => {
  const history = useHistory();

  /* legacy/workaround: suite payloads don't carry the property name, so pass it
   * via nav state for the Strata Manager sidebar breadcrumb to read. */
  const goToUnit = () => {
    history.push({ pathname: to, state: { propertyName } });
  };

  return (
    <div className="strata-manager-unit-card">
      {unit.isCommonArea && (
        <div className="strata-manager-unit-card-badge">
          <CategoryPill
            text="Common Area"
            size="small"
            color={Colors.toggleAndButtonColor}
          />
        </div>
      )}

      <h5 className="strata-manager-unit-card-number">
        <button
          type="button"
          className="strata-manager-unit-card-number-link"
          onClick={goToUnit}
        >
          {unit.unitNumber}
        </button>
      </h5>

      {unit.building && (
        <p className="strata-manager-unit-card-building">{unit.building}</p>
      )}
    </div>
  );
};

export default StrataManagerUnitCard;